import { RpcForwardReportData, RpcForwardResponse } from './rpc-forward-model';

/**
 * Rpc forward up sever side handler interface.
 */
export interface RpcForwardUpHandler<T> {
    handler(data: RpcForwardReportData): Promise<RpcForwardResponse<T>>;
}
